import * as React from "react"
import { SVGProps } from "react"

export const FuseSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={363}
    height={149}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y={0.576} width={363} height={148} rx={8} fill="#F3F3F3" />
    <path
      d="m170.743 48.236 10.315-5.957a.955.955 0 0 1 .952 0l27.185 15.696c.294.17.475.483.478.822l.036 10.795a.95.95 0 0 1-.477.828l-10.301 5.948a.953.953 0 0 1-1.429-.822l-.034-9.688a.953.953 0 0 0-.477-.822l-26.248-15.15a.952.952 0 0 1 0-1.65ZM164.08 97.133l-10.312-5.954a.947.947 0 0 1-.478-.824V58.963c0-.339.181-.652.475-.824l9.332-5.432a.947.947 0 0 1 .955 0l10.301 5.948a.954.954 0 0 1 .002 1.65l-8.371 4.872a.95.95 0 0 0-.475.825v30.31a.952.952 0 0 1-1.429.824v-.003ZM209.71 78.444v11.908a.947.947 0 0 1-.478.825l-27.185 15.695a.947.947 0 0 1-.949 0l-9.369-5.366a.954.954 0 0 1-.48-.828V88.784c0-.731.79-1.189 1.426-.827l8.406 4.816c.293.17.655.166.949 0l26.247-15.156a.953.953 0 0 1 1.43.824l.003.003Z"
      fill="#000"
    />
  </svg>
)

